(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.product_item').forEach(function(card) {

    // ✅ Agar template mein already hover image hai to skip karo
    if (card.querySelector('.img-product-hover')) return;

    // Sirf un cards ke liye JS chalao jahan data-second-image ho
    let secondImg = card.getAttribute('data-second-image');
    if (!secondImg) return;

    let findImgLink = card.querySelector('.engoj_find_img');
    if (!findImgLink) return;

    let img = findImgLink.querySelector('img');
    if (!img) return;

    let hoverImg = document.createElement('img');
    hoverImg.src = secondImg;
    hoverImg.classList.add('img-product-hover');
    findImgLink.appendChild(hoverImg);

  });

});

  } catch(e) { console.error(e); }
})();
})();
